/* eslint-disable no-dupe-keys */
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Container,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import Page from "src/components/Page";
import {
  CourierOrdersList,
  getAllRider,
  ordersSchool,
  packageList,
  schoolList,
} from "../api";
import { useSnackbar } from "notistack";
import { useQuery } from "react-query";
import "jspdf-autotable";
import Label from "src/components/Label";
import useSettings from "src/hooks/useSettings";
import Iconify from "src/components/Iconify";
import { SiteItem } from "src/sections/@dashboard/general/analytics/AnalyticsTrafficBySite";
import { fDateTime, fDateTimeNew } from "src/utils/formatTime";
import { DatePicker } from "@mui/lab";

import WithoutPagination from "src/components/mrt-table/WithoutPagination";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ViewProduct from "./ViewProduct";
import AddRider from "../order/Add";
import MultipleOrderUpdate from "./MultipleOrderUpdate";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// const ViewProduct = Loadable(lazy(() => import("./ViewProduct")));

export const productStatusList = [
  { label: "Dispatch", value: 4 }, //generate label
  { label: "Packed", value: 5 }, //generate label
  { label: "Delivered", value: 6 },
  { label: "Partial Delivered", value: 7 }, //generate label
  { label: "Cancelled", value: 8 },
  { label: "Refund", value: 9 },
  { label: "RTO", value: 10 }, //generate label
  { label: "Pending", value: 11 }, //generate label
  // { label: "Payment Initiated", value: 12 }, //generate label
  // { label: "Payment Failed", value: 13 }, //generate label
];

export const getStatusColor = (status) => {
  const error = [
    "Cancelled",
    "Refund",
    "Payment Initiated",
    "Payment Failed",
    "RTO",
  ];
  const warning = ["Partial Delivered", "Pending", "Processing"];
  const info = ["Delivered"];
  if (status) {
    if (error.includes(status)) {
      return "error";
    }
    if (warning.includes(status)) {
      return "primary";
    }
    if (info.includes(status)) {
      return "info";
    }
    return "success";
  }
  return "success";
};

export default function CourierDashboard() {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const [selectedSchool, setSelectedSchool] = useState("");
  const [selectedRider, setSelectedRider] = useState("");
  const [selectedPackage, setSelectedPackage] = useState("");
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedShippingType, setSelectedShippingType] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openMultiUpdate, setOpenMultiUpdate] = useState(false);

  const currentYear = new Date().getFullYear();

  const [selectedYears, setSelectedYears] = useState([currentYear]);

  const columns = [
    {
      accessorKey: "status",
      header: "Status",
      size: 160,

      Cell: ({ renderedCellValue, row }) => (
        <Label variant={"ghost"} color={getStatusColor(row?.original?.status)}>
          {renderedCellValue}
        </Label>
      ),
    },
    {
      accessorKey: "shippingType",
      header: "Shipping Type",
    },
    {
      accessorKey: "packageName",
      header: "Package Name",
    },
    {
      accessorKey: "orderID",
      header: "Order ID",
    },
    {
      accessorKey: "paymentDate",
      header: "Order Date",
      Cell: ({ row }) => {
        const paymentDate = row?.original?.paymentDate;
        return <>{paymentDate ? fDateTime(paymentDate) : "-"}</>;
      },
    },
    {
      accessorKey: "firstName",
      header: "Student Name",
      Cell: ({ row }) => (
        <span>
          {row.original.firstName} {row.original.lastName}
        </span>
      ),
    },
    {
      accessorKey: "address",
      header: "Address",
      size: 230,
      Cell: ({ renderedCellValue, row }) => (
        <Typography variant="body2">
          {row.original.address1} {row.original.address2} {row.original.city}{" "}
          {row.original.stateName} {row.original.pin}{" "}
        </Typography>
      ),
    },

    {
      accessorKey: "mobile",
      header: "Mobile No.",
      size: 150,
    },

    // {
    //   accessorKey: "totalAmount",
    //   header: "Total",
    //   size: 150,
    //   Cell: ({ renderedCellValue, row }) => (
    //     <Typography variant="body2" fontWeight={500} color="green">
    //       {formatAsINR(renderedCellValue)}
    //     </Typography>
    //   ),
    // },
    {
      accessorKey: "lotNumber",
      header: "Lot Number",
      // size: 150,
    },
    {
      accessorKey: "rider_name",
      header: "Rider Name",
      // size: 150,
    },
  ];

  const { data, isFetched } = useQuery({
    queryKey: ["schoolList"],
    queryFn: schoolList,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
  const { data: RiderList } = useQuery({
    queryKey: ["getAllRider"],
    queryFn: getAllRider,
  });
  const { data: PackageList } = useQuery({
    queryKey: ["getData", selectedSchool],
    queryFn: packageList,
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: !!selectedSchool,
  });

  const { data: orderList, isLoading } = useQuery({
    queryKey: [
      "courier-orderList",
      "",
      selectedRider,
      selectedSchool,
      selectedPackage,
      selectedStatus?.map((el) => el.value)?.join(","),
      fromDate ? fDateTimeNew(fromDate) : undefined,
      toDate ? fDateTimeNew(toDate) : undefined,
      selectedShippingType,
      selectedYears,
    ],
    queryFn: CourierOrdersList,
  });

  // const { data: orderCount } = useQuery({
  //   queryKey: ["ordersSchool", selectedSchool, selectedYears],
  //   queryFn: ordersSchool,
  //   enabled: !!selectedSchool,
  // });

  const { data: orderCount } = useQuery({
    queryKey: [
      "ordersSchool",
      selectedSchool,
      selectedPackage,
      selectedStatus?.map((el) => el.value)?.join(","),
      fromDate ? fDateTimeNew(fromDate) : undefined,
      toDate ? fDateTimeNew(toDate) : undefined,
      selectedShippingType,
      selectedYears,
    ],
    queryFn: ordersSchool,
    enabled: !!selectedSchool,
  });

  useEffect(() => {
    if (isFetched) {
      setSelectedSchool(data?.data[0]?.schoolID);
    }
  }, [isFetched]);
  return (
    <Page title="General:Courier">
      {open && (
        <AddRider
          onClose={() => {
            setOpen(false);
            setSelectedRow(null);
          }}
          row={selectedRow}
        />
      )}
      {openMultiUpdate && (
        <MultipleOrderUpdate
          data={selectedRows}
          onClose={() => {
            setOpenMultiUpdate(false);
            setSelectedRows([]);
          }}
        />
      )}
      <Container maxWidth={themeStretch ? false : "xl"} id={"report"}>
        {selectedRecord ? (
          <ViewProduct
            onClose={() => {
              setSelectedRecord(null);
            }}
            row={selectedRecord}
            selectedSchool={selectedSchool}
          />
        ) : (
          <>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <TextField
                  label="School"
                  size="small"
                  select
                  // SelectProps={{ native: false }}
                  fullWidth
                  // sx={{ maxWidth: "250px", width: "100%" }}
                  value={selectedSchool}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setSelectedSchool(e.target.value);
                    setSelectedPackage("");
                  }}
                  SelectProps={{
                    displayEmpty: true,
                  }}
                  inputProps={{
                    placeholder: "Choose a School",
                  }}
                >
                  {/* <MenuItem value={""}>Choose a School</MenuItem>  */}
                  {data &&
                    data?.data?.map((el) => (
                      <MenuItem value={el.schoolID} key={el.schoolID}>
                        {el.schoolName}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Rider"
                  size="small"
                  select
                  // SelectProps={{ native: false }}
                  fullWidth
                  value={selectedRider}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setSelectedRider(e.target.value);
                  }}
                  SelectProps={{
                    displayEmpty: true,
                  }}
                  inputProps={{
                    placeholder: "Choose a option",
                  }}
                >
                  <MenuItem value={""}>Choose a option</MenuItem>
                  {RiderList?.map((el, index) => (
                    <MenuItem value={el.id} key={el.id}>
                      {el?.fullName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Package"
                  size="small"
                  select
                  // SelectProps={{ native: false }}
                  // sx={{ maxWidth: "250px", width: "100%" }}
                  disabled={!selectedSchool}
                  fullWidth
                  value={selectedPackage}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setSelectedPackage(e.target.value);
                  }}
                  SelectProps={{
                    displayEmpty: true,
                  }}
                  inputProps={{
                    placeholder: "Choose an Package",
                  }}
                >
                  <MenuItem value="">Choose a Package</MenuItem>
                  {PackageList &&
                    PackageList?.data?.map((el) => (
                      <MenuItem value={el.packageID} key={el.packageID}>
                        {el.packageName}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  multiple
                  options={productStatusList}
                  size="small"
                  limitTags={2}
                  value={selectedStatus}
                  onChange={(e, value) => {
                    setSelectedStatus(value);
                  }}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.label}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.label}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Order Flag"
                      placeholder="Select Status"
                      size="small"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <DatePicker
                  label="Order From"
                  value={fromDate}
                  clearable
                  disabled={!selectedSchool}
                  onChange={(value) => {
                    setFromDate(value);
                    setToDate(null);
                  }}
                  disableFuture
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <DatePicker
                  label="Order to"
                  value={toDate}
                  clearable
                  onChange={(value) => {
                    setToDate(value);
                  }}
                  disableFuture
                  disabled={!fromDate}
                  minDate={fromDate}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Shipping Type"
                  select={true}
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: false }}
                  value={selectedShippingType}
                  onChange={(e) => {
                    setSelectedShippingType(e.target.value);
                  }}
                  fullWidth
                  size="small"
                >
                  <MenuItem>Select Option</MenuItem>
                  <MenuItem value="1">Standard</MenuItem>
                  <MenuItem value="2">Express</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  multiple
                  options={Array.from({ length: 10 }, (_, i) => currentYear - i)} // Generate last 10 years from current year
                  size="small"
                  limitTags={2}
                  value={selectedYears}
                  onChange={(e, value) => {
                    if (value.length === 0) {
                      setSelectedYears([currentYear]);
                    } else {
                      setSelectedYears(value); 
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Years"
                      placeholder="Choose Years"
                      size="small"
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Box mt={4}>
              <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Total Order"
                    order={orderCount ? orderCount[0]?.totalOrders : "-"}
                    price={orderCount ? orderCount[0]?.totalAmount : "-"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="New Order"
                    order={orderCount ? orderCount[0]?.Created : "-"}
                    price={orderCount ? orderCount[0]?.createdAmount : "-"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Packed"
                    order={orderCount ? orderCount[0]?.packed : "-"}
                    price={orderCount ? orderCount[0]?.packedAmount : "-"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Delivered"
                    order={orderCount ? orderCount[0]?.delivered : "-"}
                    price={orderCount ? orderCount[0]?.deliveredAmount : "-"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Out For Devlivery"
                    order={orderCount ? orderCount[0]?.out_for_deliver : "-"}
                    price={
                      orderCount ? orderCount[0]?.outForDeliverAmount : "-"
                    }
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Partial Delivered"
                    order={orderCount ? orderCount[0]?.partial_delivered : "-"}
                    price={
                      orderCount ? orderCount[0]?.partial_deliveredAmount : "-"
                    }
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="In Progress"
                    order={orderCount ? orderCount[0]?.Processing : "-"}
                    price={orderCount ? orderCount[0]?.processingAmount : "-"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Cancelled"
                    order={orderCount ? orderCount[0]?.cancelled : "-"}
                    price={orderCount ? orderCount[0]?.cancelledAmount : "-"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Refund"
                    order={orderCount ? orderCount[0]?.refund : "-"}
                    price={orderCount ? orderCount[0]?.refundAmount : "-"}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Pending"
                    order={orderCount ? orderCount[0]?.pending : "-"}
                    price={orderCount ? orderCount[0]?.pendingAmount : "-"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="RTO"
                    order={orderCount ? orderCount[0]?.rto : "-"}
                    price={orderCount ? orderCount[0]?.rtoAmount : "-"}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="h6">
                    Delivery Methods Wise Count
                  </Typography>
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Express"
                    order={orderCount ? orderCount[0]?.Express : "-"}
                    price={orderCount ? orderCount[0]?.expressAmount : "-"}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <SiteItem
                    title="Standard"
                    order={orderCount ? orderCount[0]?.Standard : "-"}
                    price={orderCount ? orderCount[0]?.standardAmount : "-"}
                  />
                </Grid>
              </Grid>

              <Box sx={{ minWidth: 3000 }}>
                <WithoutPagination
                  data={orderList || []}
                  columns={columns}
                  loading={isLoading}
                  enableRowSelection
                  enableSelectAll
                  selectAllMode="all"
                  renderRowActions={({ row }) => (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <IconButton
                        onClick={() => {
                          setOpen(true);
                          setSelectedRow(row.original);
                        }}
                        disabled={
                          row.original.status === "Delivered" ||
                          row.original.status === "Out For Delivery"
                        }
                      >
                        <Iconify icon={"ic:baseline-delivery-dining"} />
                      </IconButton>
                    </Box>
                  )}
                  displayColumnDefOptions={{
                    "mrt-row-actions": {
                      size: "100",
                    },
                  }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "16px",
                        padding: "8px",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        variant="contained"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        onClick={() => {
                          setOpenMultiUpdate(true);
                          setSelectedRows(table?.getSelectedRowModel()?.rows);
                        }}
                      >
                        Change Status(Order Wise)
                      </Button>
                    </Box>
                  )}
                />
              </Box>
            </Box>
          </>
        )}
      </Container>
    </Page>
  );
}
